// eslint-disable-next-line no-unused-vars
import React, { memo, useState } from 'react';
import { bool, func, object, string } from 'prop-types';
import { useTranslation } from 'react-i18next';

import ProductOfferItemComponent from 'Components/Products/ProductOfferItem';
import useAnalytics from 'Hooks/useAnalytics';
import useToastNotifications from 'Hooks/useToastNotifications';

const ProductOfferItem = memo(({ offer, product, storage, disabled, onRemove }) => {
  const { t } = useTranslation();
  const analytics = useAnalytics();
  const toast = useToastNotifications();
  const [loading, setLoading] = useState(false);

  const handleRemove = async event => {
    event.stopPropagation();
    if (disabled) return;
    setLoading(true);
    try {
      await onRemove(product);
      analytics.track('mini_offer_product_removed', {
        offer_id: offer.id,
        product_id: product.productId || product.id,
        storage
      });
    } catch (error) {
      toast.addNotification({
        type: 'error',
        title: error?.info?.errors?.at(0)?.message
          || error?.message
          || t('offers.productRemoveFailed')
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <ProductOfferItemComponent
      product={ product }
      isSavedOffer={ storage === 'saved' }
      loading={ loading }
      disabled={ disabled }
      onDelete={ handleRemove }
    />
  );
});

ProductOfferItem.propTypes = {
  offer: object,
  product: object,
  storage: string,
  disabled: bool,
  onRemove: func
};

ProductOfferItem.displayName = 'ProductOfferItemContainer';

export default ProductOfferItem;
